export default function ContactRow({ rowItem }) {
  return (
    <div className="row">
      <div className="key">{rowItem.OFF_TYPE} :</div>
      <div className="key">{rowItem.OFFICER_NAME} :</div>
      <div className="value">{rowItem.MOBILENO}</div>
    </div>
  );
}
